export const PRODUCT_API_CONSTANTS = {
    SEO_DETAILS: "seoDetails",  
  };